<div
  class="fixed top-0 right-0 bottom-0 left-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-xs"
  (keydown)="cancel()"
  (click)="cancel()">
  <div
    class="bg-surface relative flex max-h-10/12 w-11/12 max-w-3xl flex-col overflow-hidden rounded-xl shadow-2xl"
    (keydown)="$event.stopPropagation()"
    (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4">
      <div class="flex items-center gap-2">
        <i [class]="ICONS.funnel" class="text-accent-main text-xl"></i>
        <h2 class="text-text-primary text-lg font-semibold">
          {{ 'filters.complex_filter_builder' | translate }}
        </h2>
      </div>
      <button
        (click)="cancel()"
        class="text-text-secondary hover:bg-interactive hover:text-text-primary cursor-pointer rounded-md border-none p-2 transition-all"
        [attr.aria-label]="'filters.close' | translate">
        <i [class]="ICONS.x"></i>
      </button>
    </div>

    <div #scrollContainer class="flex-1 overflow-y-auto p-6" (scroll)="onScroll($event)">
      <div class="mb-6">
        @if (localConfig().rootGroup) {
          <div class="border-default bg-surface rounded-lg border-2 p-4">
            <div class="mb-4 flex items-center gap-3">
              <button
                (click)="toggleGroupConnector(localConfig().rootGroup)"
                class="border-default bg-accent-main cursor-pointer rounded-md border px-3 py-1 text-sm font-semibold text-white uppercase transition-opacity"
                type="button">
                {{
                  `filters.connector.${localConfig().rootGroup.connector.toLowerCase()}`
                    | translate
                }}
              </button>
              <span class="text-text-secondary text-sm">
                {{ 'filters.match_conditions' | translate }}
              </span>
            </div>

            <div class="border-default flex flex-col gap-2 border-l-2 pl-6">
              @for (item of localConfig().rootGroup.conditions; track trackByItem(item)) {
                @if (isGroup(item)) {
                  <div class="mx-0 my-1">
                    <ng-container
                      [ngTemplateOutlet]="groupTemplate"
                      [ngTemplateOutletContext]="{
                        $implicit: item,
                        parentId: localConfig().rootGroup.id
                      }">
                    </ng-container>
                  </div>
                }

                @if (isCondition(item)) {
                  <div class="flex items-center gap-2">
                    <button
                      #conditionElement
                      (click)="
                        editCondition(item, localConfig().rootGroup.id, conditionElement)
                      "
                      class="border-default bg-surface text-text-primary hover:bg-elevated hover:border-accent-main flex flex-1 cursor-pointer items-center gap-3 rounded-md border px-2 py-3 text-left text-sm transition-all">
                      <i
                        [class]="filterOpsService.getDataTypeIcon(item.dataType)"
                        class="text-text-secondary"></i>
                      <span class="flex-1 text-left">{{ getConditionSummary(item) }}</span>
                    </button>
                    <button
                      (click)="removeItem(item.id, localConfig().rootGroup.id)"
                      class="cursor-pointer rounded-sm border-none bg-red-500/10 p-1 text-red-500 opacity-0 transition-opacity hover:opacity-100"
                      type="button">
                      <i [class]="ICONS.x"></i>
                    </button>
                  </div>
                }
              }

              <div class="mt-2 flex gap-2">
                <button
                  (click)="addConditionToGroup(localConfig().rootGroup, $event)"
                  class="border-default text-text-secondary hover:bg-elevated hover:border-accent-main hover:text-accent-main flex cursor-pointer items-center gap-1 rounded-md border border-dashed bg-transparent px-3 py-2 text-sm transition-all hover:border-solid"
                  type="button">
                  <i [class]="ICONS.plus"></i>
                  <span>{{ 'filters.add_filter' | translate }}</span>
                </button>
                <button
                  (click)="addSubGroup(localConfig().rootGroup)"
                  class="border-default text-text-secondary hover:bg-elevated hover:border-accent-main hover:text-accent-main flex cursor-pointer items-center gap-1 rounded-md border border-dashed bg-transparent px-3 py-2 text-sm transition-all hover:border-solid"
                  type="button">
                  <i [class]="ICONS.brackets"></i>
                  <span>{{ 'filters.add_group' | translate }}</span>
                </button>
              </div>
            </div>
          </div>
        }
      </div>

      <div class="bg-elevated border-default flex gap-3 rounded-lg border p-4">
        <i [class]="ICONS.lightbulb" class="text-accent-main"></i>
        <p class="text-text-secondary text-sm">
          {{ 'filters.complex_filter_help' | translate }}
        </p>
      </div>
    </div>

    <div class="scroll-fade-top" [class.visible]="showTopFade()"></div>

    <div class="scroll-fade-bottom" [class.visible]="showBottomFade()"></div>

    <div class="flex justify-end gap-3 px-6 py-5">
      <button
        (click)="cancel()"
        class="text-text-primary border-default hover:bg-interactive cursor-pointer rounded-md border bg-transparent px-5 py-2 text-sm font-medium transition-all"
        type="button">
        {{ 'filters.cancel' | translate }}
      </button>
      <button
        (click)="apply()"
        class="bg-accent-main cursor-pointer rounded-md px-5 py-2 text-sm font-medium text-white transition-all"
        type="button">
        {{ 'filters.apply' | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Recursive group template -->
<ng-template #groupTemplate let-group let-parentId="parentId">
  <div class="border-accent-main bg-page rounded-lg border-2 p-4">
    <div class="mb-4 flex items-center gap-3">
      <button
        (click)="toggleGroupConnector(group)"
        class="border-default bg-accent-main cursor-pointer rounded-md border px-3 py-1 text-sm font-semibold text-white uppercase transition-opacity"
        type="button">
        {{ `filters.connector.${group.connector.toLowerCase()}` | translate }}
      </button>
      <span class="text-text-secondary text-sm">
        {{ 'filters.match_conditions' | translate }}
      </span>
      <button
        (click)="removeItem(group.id, parentId)"
        class="ml-auto cursor-pointer rounded-sm border-none bg-red-500/10 p-1 text-red-500 opacity-0 transition-opacity hover:opacity-100"
        type="button">
        <i [class]="ICONS.trash" class="text-sm"></i>
      </button>
    </div>

    <div class="border-default flex flex-col gap-2 border-l-2 pl-6">
      @for (item of group.conditions; track trackByItem(item)) {
        @if (isGroup(item)) {
          <div class="mx-0 my-1">
            <ng-container
              [ngTemplateOutlet]="groupTemplate"
              [ngTemplateOutletContext]="{ $implicit: item, parentId: group.id }">
            </ng-container>
          </div>
        }

        @if (isCondition(item)) {
          <div class="flex items-center gap-2">
            <button
              #conditionElement
              (click)="editCondition(item, group.id, conditionElement)"
              class="border-default bg-surface text-text-primary hover:bg-elevated hover:border-accent-main flex flex-1 cursor-pointer items-center gap-3 rounded-md border px-2 py-3 text-left text-sm transition-all">
              <i
                [class]="filterOpsService.getDataTypeIcon(item.dataType)"
                class="text-text-secondary"></i>
              <span class="flex-1 text-left">{{ getConditionSummary(item) }}</span>
            </button>
            <button
              (click)="removeItem(item.id, group.id)"
              class="cursor-pointer rounded-sm border-none bg-red-500/10 p-1 text-red-500 opacity-0 transition-opacity hover:opacity-100"
              type="button">
              <i [class]="ICONS.x"></i>
            </button>
          </div>
        }
      }

      <div class="mt-2 flex gap-2">
        <button
          (click)="addConditionToGroup(group, $event)"
          class="border-default text-text-secondary hover:bg-elevated hover:border-accent-main hover:text-accent-main flex cursor-pointer items-center gap-1 rounded-md border border-dashed bg-transparent px-3 py-2 text-sm transition-all hover:border-solid"
          type="button">
          <i [class]="ICONS.plus"></i>
          <span>{{ 'filters.add_filter' | translate }}</span>
        </button>
        <button
          (click)="addSubGroup(group)"
          class="border-default text-text-secondary hover:bg-elevated hover:border-accent-main hover:text-accent-main flex cursor-pointer items-center gap-1 rounded-md border border-dashed bg-transparent px-3 py-2 text-sm transition-all hover:border-solid"
          type="button">
          <i [class]="ICONS.brackets"></i>
          <span>{{ 'filters.add_group' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Add filter dropdown template -->
<ng-template #addFilterTemplate>
  <app-add-filter-dropdown
    [availableFields]="availableFields()"
    [activeFilters]="[]"
    [displayComplexFilterOption]="false"
    (dropdownClose)="dropdownService.close()"
    (addFiltering)="handleAddFilter($event)">
  </app-add-filter-dropdown>
</ng-template>

<ng-template #filterPopupTemplate>
  <app-filter-popup
    [filterCondition]="editingCondition()!.condition"
    [availableValues]="availableValuesForEditingCondition()"
    (updateFiltering)="updateCondition($event)"
    (removeFiltering)="
      removeItem(editingCondition()!.condition.id, editingCondition()!.groupId)
    "
    (closePopup)="dropdownService.close()" />
</ng-template>
